(() => {
  function init(root) {
    root.querySelectorAll('[data-bea-sort]').forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      const grid = form.closest('.BeaCollection').querySelector('.BeaCollection__grid');
      if (Number(grid.dataset.pages) > 1) return;
      const cards = Array.from(grid.children);
      const priority = ['kurkuma-gold-serum','botaniq-serum','sanddorn-regenerierende-gesichtscreme','kaktusfeige-anti-aging-nachtcreme','granatapfel-anti-aging-gesichtscreme','augen-roll-on'];
      const rank = card => { const i = priority.indexOf(card.dataset.product); return i < 0 ? 100 : i; };
      function sort() {
        const value = form.elements.sort_by.value;
        const sorted = cards.slice().sort((a,b) => {
          if (value === 'price-ascending') return Number(a.dataset.price)-Number(b.dataset.price);
          if (value === 'price-descending') return Number(b.dataset.price)-Number(a.dataset.price);
          if (value === 'title-ascending') return a.dataset.title.localeCompare(b.dataset.title,(document.documentElement.lang || 'de'));
          return rank(a)-rank(b);
        });
        sorted.forEach(card => grid.appendChild(card));
      }
      sort();
      form.addEventListener('submit', event => { event.preventDefault(); sort(); });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
